export class Search
{
    searchstoreid: string;
    searchmerchantreference: string;       
    searchbasketid: string;
    searchfromdate: string;
    searchtodate: string;
    searchstatus: string;
    searchsmartcard:string;
}


// WEBPACK FOOTER //
// /tmp/build_713add00/src/models/searchmodel.ts